/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Replay15Line = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2A10 10 0 1 1 2 12h2a8 8 0 1 0 1.39-4.5H8v2H2v-6h2V6a10 10 0 0 1 8-4M8.5 15.5v-7H10v7zm3.5-7h4.75V10H13.5v1.25h1.38a2.13 2.13 0 0 1 0 4.25H12V14h2.88a.63.63 0 1 0 0-1.25H12z" />
  </Icon>
);
